import { NeoModel, ValueObject, Attributes } from '@singularsystems/neo-core';

@NeoModel
export default class MyProxyParticipantLookupCriteria extends ValueObject {

    @Attributes.Display("Filter")
    public participantName: string = "";
    
    // Client only properties / methods
}